var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("LayoutLeftAuth"),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-5 password-success" }, [
          _c(
            "div",
            {
              staticClass:
                "container h-full d-flex align-items-center justify-content-center"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "row d-flex flex-column text-center align-items-center"
                },
                [
                  _c("img", {
                    staticClass: "logo-mobile-auth d-block d-sm-none",
                    attrs: { src: require("../../assets/img/blue-logo.png") }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "changed-title" }, [
                    _vm._v("\n            Password changed!\n          ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "changed-undertitle" },
                    [
                      _vm._v(
                        "\n            You've successfully changed your password. Proceed to "
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "thick-font changed-router-links",
                          attrs: { to: "/login" }
                        },
                        [_vm._v("login.")]
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62e1031a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e1031a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/SetNewPasswordSuccess.vue
// module id = null
// module chunks = 